module.exports = __webpack_public_path__ + "img/3-3.7fcb87f5.svg";